import { useTranslation } from "react-i18next"

import MyModal from "@/components/MyModal/MyModal"
import { MODALS } from "@/constants/modals"

import AdditionalMaterialPreview from "./LecturesDetails/AdditionalMaterialPreview"
import AttendLectureModal from "./LecturesDetails/AttendLectureModal"
import DriveVideoPreview from "./LecturesDetails/DriveVideoPreview"
import LectureAdditionalMaterialsModal from "./LecturesDetails/LectureAdditionalMaterialsModal"
import LectureContentModal from "./LecturesDetails/LectureContentModal"
import LectureMentorSessionsModal from "./LecturesDetails/LectureMentorSessionsModal"
import LecturesProjectsModal from "./LecturesDetails/LectureProjectsModal"
import LectureTasksModal from "./LecturesDetails/LectureTasksModal"
import MindMapModal from "./MindMapModal"
import TaskUpload from "./TaskUpload"

export default function EnrolledCoursesModals() {
  const { t } = useTranslation()
  return (
    <>
      {/* <MyModal
        modalName={MODALS.feedbacks.index}
        title={t("enrolledCoursesModalsTitles.feedback")}
      >
        <FeedbackModal />
      </MyModal> */}
      <MyModal
        modalName={MODALS.lecture.uplaodTask}
        title={t("enrolledCoursesModalsTitles.taskUpload")}
      >
        <TaskUpload />
      </MyModal>
      <MyModal
        size={"lg"}
        modalName={MODALS.lecture.preivewDrive}
        title={t("enrolledCoursesModalsTitles.videoPreview")}
      >
        <DriveVideoPreview />
      </MyModal>
      <MyModal
        size={"lg"}
        modalName={MODALS.lecture.previewAdditionalMaterial}
        title={t("enrolledCoursesModalsTitles.materialPreview")}
      >
        <AdditionalMaterialPreview />
      </MyModal>
      <MyModal
        size={"lg"}
        modalName={MODALS.lecture.tasks}
        title={t("enrolledCoursesModalsTitles.lectureTasks")}
      >
        <LectureTasksModal />
      </MyModal>
      <MyModal
        size={"lg"}
        modalName={MODALS.lecture.projects}
        title={t("enrolledCoursesModalsTitles.lectureProjects")}
      >
        <LecturesProjectsModal />
      </MyModal>
      <MyModal
        size={"lg"}
        modalName={MODALS.lecture.mentorSessions}
        title={t("enrolledCoursesModalsTitles.lectureMentorSessions")}
      >
        <LectureMentorSessionsModal />
      </MyModal>
      <MyModal
        size={"lg"}
        modalName={MODALS.lecture.additionalMaterials}
        title={t("enrolledCoursesModalsTitles.lectureAdditionalMaterials")}
      >
        <LectureAdditionalMaterialsModal />
      </MyModal>
      <MyModal
        size={"lg"}
        modalName={MODALS.lecture.content}
        title={t("enrolledCoursesModalsTitles.lectureContent")}
      >
        <LectureContentModal />
      </MyModal>
      <MyModal
        size={"lg"}
        modalName={MODALS.lecture.attend}
        title={t("enrolledCoursesModalsTitles.attendLecture")}
      >
        <AttendLectureModal />
      </MyModal>
      <MyModal
        size={"xl"}
        modalName={MODALS.round.mindMap}
        title={t("enrolledCoursesModalsTitles.mindMap")}
      >
        <MindMapModal />
      </MyModal>
    </>
  )
}
